import { Navigate } from 'react-router-dom'
import { useUser } from '../hooks/useUser'
import Loader from '../components/layouts/Loader'
import { isEmpty } from 'lodash'
import { usePageAccess } from '../hooks/usePageAccess'

export default function RequiredAdminRoute({ children }) {
  const { isLoading, isFetched } = useUser()
  const { data, isLoading: isPermissionLoading } = usePageAccess()

  if (isLoading || !isFetched || isPermissionLoading) {
    return <Loader />
  }

  if (isEmpty(data)) {
    return <Navigate to="/404" />
  }

  return children
}
